export interface TicketOptions {
  eviction?: EvictionTypes;
}

export type EvictionTypes = 'onfetch' | 'never' | number;

export interface IParamsStore {
  ticket(data: unknown, options?: TicketOptions): Promise<string>;
  ticketValue<T>(id: string): Promise<T | undefined>;
  removeTicket(id: string): Promise<void>;
}

export interface EvectionCtx {
  currentTS: number;
  fetch: boolean;
}

export interface TicketValue {
  value: unknown;
  evictionTS: number;
  eviction: EvictionTypes;
}

/**
 * If a value is stored with eviction sets to "onfetch",
 * this constant configures the maximum time that it will be stored until fetched.
 */
export const ONFETCH_TTL = 60 * 1000;

export function checkEviction(
  ticketValue: TicketValue,
  context: EvectionCtx
): boolean {
  let evicted = false;
  switch (ticketValue.eviction) {
    case 'never':
      break;
    case 'onfetch':
      if (context.fetch) {
        evicted = true;
      } else {
        evicted = context.currentTS > ticketValue.evictionTS;
      }
      break;
    default:
      evicted = context.currentTS > ticketValue.evictionTS;
  }
  return evicted;
}

export function getEvictionTS(eviction: EvictionTypes): number {
  let result;
  switch (eviction) {
    case 'never':
      result = -1;
      break;
    case 'onfetch':
      result = Date.now() + ONFETCH_TTL;
      break;
    default:
      result = Date.now() + eviction;
  }
  return result;
}
